import React, { useEffect, useState } from "react";
import { FaArrowDown } from "react-icons/fa";
import styled from "styled-components";
import { supabase } from "../../client";

const Orders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await supabase
        .from("orders")
        .select()
        .eq("user_id", supabase.auth.user().id);
      setOrders(data);
    };
    fetchData();
  }, []);

  return (
    <Right style={{ marginBottom: "5em" }}>
      <Heading>MY ORDERS</Heading>
      <OrderCard style={{ fontWeight: "500", marginTop: "1em" }}>
        <Order style={{ padding: ".5em" }}>ORDER</Order>
        <OrderDate style={{ padding: ".5em" }}>DATE</OrderDate>
        <Status style={{ padding: ".5em" }}>STATUS</Status>
        <Total style={{ padding: ".5em" }}>TOTAL</Total>
        <More></More>
      </OrderCard>

      {orders.map((order) => {
        return (
          <OrderCard>
            <Order>#{orders.indexOf(order) + 1}</Order>
            <OrderDate>
              {new Date(order.created_at).toLocaleDateString()}
            </OrderDate>
            <Status>{order.status.toUpperCase()}</Status>
            <Total>
              ${order.total_price} for {order.total_quantity} items
            </Total>
            <More>
              <FaArrowDown />
            </More>
          </OrderCard>
        );
      })}
    </Right>
  );
};

const Right = styled.div`
  width: 75%;
  border: 1px solid #ddd;
  padding: 2em;
  form {
    display: flex;
    flex-direction: column;
  }
  input,
  button {
    padding: 1em;
    margin: 1em 0;
  }
  input {
    border: 1px solid #ddd;
  }
`;

const Heading = styled.div`
  color: #525252;
  font-size: 1.3rem;
  font-weight: 500;
`;
const OrderCard = styled.div`
  display: flex;
  width: 100%;
`;
const Order = styled.div`
  width: 15%;
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  padding: 1em;
`;
const OrderDate = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  width: 25%;
  padding: 1em;
`;
const Status = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  width: 20%;
  padding: 1em;
`;
const Total = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  width: 30%;
  padding: 1em;
`;
const More = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  width: 10%;
  padding: 1em;
  & > * {
    cursor: pointer;
    width: 100%;
    transition: color 0.3s;
    :hover {
      color: #83aa4c;
    }
  }
`;

export default Orders;
